import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setBeefHerdSize, setBeefHerdSizeAdmin } from "services";

import { footprintingBeefPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_BEEF_HERD_SIZE } from "consts";

import { FootprintingBeefHerdSize, UploadableBeefHerdSize } from "models";

export const useMutateFootprintingBeefHerdSize = (primaryDataId: string, farmId: string, year: number) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation<FootprintingBeefHerdSize[], Error, UploadableBeefHerdSize[]>({
    mutationKey: [FOOTPRINTING_BEEF_HERD_SIZE, primaryDataId, isAdmin],
    mutationFn: (data) => (isAdmin ? setBeefHerdSizeAdmin(primaryDataId, data) : setBeefHerdSize(primaryDataId, data)),
    onSuccess: () => {
      invalidateAndRefecthQueries(queryClient, [
        [FOOTPRINTING_BEEF_HERD_SIZE, primaryDataId, isAdmin],
        ...footprintingBeefPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
      ]);
    },
  });
};
